<template>
    <div id="publication_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerHeader1" v-if="isEdit">Update Publication</span>
                    <span class="page-title" id="customerHeader2" v-else>Create Publication</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content customer-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="needs-validation" novalidate id="PublicationForm">
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <div class="d-flex justify-content-between">
                                            <label class="control-label require" for="document_title">Document
                                            Title:</label>
                                            <span style="font-size: 14px;">{{ document_title_count }}/100</span>
                                        </div>
                                        <input type="text" class="form-control" v-model.trim="document_title"
                                            id="document_title" placeholder="Document Title" name="document_title">
                                        <span class="field-error">{{ document_title_error_msg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <label class="control-label require" for="department">Departments:</label>
                                            <div class="form-check">
                                                <input class="form-check-input" @change="selectAllDepartments($event)" type="checkbox" value="" id="departmentsCheckbox">
                                                <label class="form-check-label" for="departmentsCheckbox">
                                                    Select All
                                                </label>
                                            </div>
                                        </div>
                                        <v-select v-model="departments" name="department" label="text"
                                            :filterable="false" :options="departmentArr"
                                            placeholder="Select Departments" class="custom-ci-auto-search"
                                            :disabled="disableFields" :closeOnSelect="false" multiple>
                                            <template slot="no-options">
                                                Search Departments...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ department_error_msg }}</div>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="document_type">Document Type:</label>
                                        <v-select v-model="document_type" name="document_type" label="text"
                                            :filterable="false" :options="documenttypeArr"
                                            placeholder="Select Document Type" class="custom-ci-auto-search"
                                            :disabled="disableFields">
                                            <template slot="no-options">
                                                Search Document Type...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ document_type_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <div class="d-flex justify-content-between">
                                            <label class="control-label require" for="publication_no">Publication
                                            Number:</label>
                                            <span style="font-size: 14px;">{{ publication_no_count }}/100</span>
                                        </div>
                                        <input type="text" class="form-control" v-model.trim="publication_no"
                                            id="publication_no" placeholder="Publication Number" name="publication_no">
                                        <span class="field-error">{{ publication_no_error_msg }}</span>
                                    </div>
                                </div>
                                <DropZone 
                                    :uniqueRef="'documentDropzone'"
                                    :showDropzone="dropZonePreviewFiles.length == 0"
                                    :showUploadedFiles="dropZonePreviewFiles.length > 0 && isEdit"
                                    :dropZonePreviewFiles="dropZonePreviewFiles"
                                    :maxFileLimit='1'
                                    :docErrorMsg="doc_error_msg"
                                    :isEdit="isEdit"
                                    @dropzone-update-files="updateFiles"
                                    @dropzone-remove-files="removeFiles"
                                />
                                <div class="btn-groups">
                                    <button type="submit" id="CreatePublicationBtn" v-if="isEdit"
                                        class="btn btn-primary" v-on:click.prevent="CreatePublication">
                                        <i class="fp-reload"> </i> Update
                                    </button>
                                    <button type="submit" id="CreatePublicationBtn" v-else class="btn btn-primary"
                                        v-on:click.prevent="CreatePublication">
                                        <i class="fp-save"> </i> Save
                                    </button>
                                    <button type="submit" id="createAndContinuePublicationBtn" v-if="!isEdit"
                                        class="btn btn-tertiary"
                                        v-on:click.prevent="CreatePublication(flag = 'Save and Continue')">
                                        <i class="fp-save-continue"> </i> Save and Continue
                                    </button>
                                    <button type="submit" id="cancelPublicationBtn" class="btn btn-tertiary"
                                        v-on:click.prevent="goPreviousPath">
                                        <i class="fp-close"> </i> Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import { commonMixins } from '../../mixins/commonMixins';
import { contractMixins } from '../../mixins/contractMixins';
import DropZone from '../DropZone.vue';

export default {
    name: "PublicationCreate",
    components: {
        DropZone,
    },
    metaInfo() {
        return {
            title: (this.isEdit == true) ? "Update Publication | " + process.env.COPYRIGHT_NAME : "Create Publication | " + process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        isEdit: false,
        disableFields: false,
        departmentArr: [],
        documenttypeArr: [],
        publicationId: 0,
        departments: '',
        document_type: '',
        document_title: '',
        publication_no: '',
        department_error_msg: "",
        document_type_error_msg: "",
        document_title_error_msg: '',
        publication_no_error_msg: '',
        document_title_count: 0,
        publication_no_count: 0,
        dropZonePreviewFiles: [],
        files: [],
        removedFiles: [],
        doc_error_msg: ''
    }),

    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_add_publication') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
        document_title(newValue){
            if (newValue.length > 100) {
                this.document_title = newValue.substring(0, 100);
            }
            this.document_title_count = newValue.length;
        },
        publication_no(newValue){
            if (newValue.length > 100) {
                this.publication_no = newValue.substring(0, 100);
            }
            this.publication_no_count = newValue.length;
        },
        departments(){
            var checkbox = document.getElementById('departmentsCheckbox');
            if(this.departments.length < this.departmentArr.length){
                if(checkbox){
                    checkbox.checked = false;
                }
            }else if(this.departments.length == this.departmentArr.length){
                if(checkbox){
                    checkbox.checked = true;
                }
            }
        },
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['publication_depart_doc_type']);

        if (self.$route.params.id !== undefined && self.$route.params.id > 0) {
            self.publicationId = self.$route.params.id;
            self.isEdit = true;
            self.loadSinglePublication();
        }
    },
    methods: {
        updateFiles(files) {
            this.files = files;
        },
        removeFiles(removedFiles) {
            this.removedFiles = removedFiles;
        },
        selectAllDepartments(event){
            if (event.target.checked) {
                this.departments = this.departmentArr;
            } else {
                this.departments = '';
            }
        },
        validateFields() {
            var self = this;
            self.department_error_msg = "";
            self.document_type_error_msg = "";
            self.document_title_error_msg = "";
            self.publication_no_error_msg = "";
            self.doc_error_msg = "";
            var error = false;

            if (self.departments == "" || self.departments == null) {
                self.department_error_msg = "Departments is Required";
                error = true;
            }

            if (self.document_type == "" || self.document_type == null) {
                self.document_type_error_msg = "Document Type is Required";
                error = true;
            }

            if (self.document_title == "" || self.document_title == null) {
                self.document_title_error_msg = "Document Title is Required";
                error = true;
            }

            if (self.publication_no == "" || self.publication_no == null) {
                self.publication_no_error_msg = "Publication Number is Required";
                error = true;
            }

            if(self.dropZonePreviewFiles.length == 0){
                if (self.files.length == 0) {
                    self.doc_error_msg = "Document File is Required";
                    error = true;
                }
            }

            return error;
        },
        CreatePublication(flag) {
            var self = this;
            var error = self.validateFields();
            if (!error) {
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/publication/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        publication_id: self.publicationId,
                        document_title: self.document_title,
                        departments: self.departments,
                        document_type: self.document_type.value,
                        publication_no: self.publication_no,
                        docs: self.files,
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == 'success') {
                            if (flag == "Save and Continue") {
                                $("#PublicationForm").trigger("reset");
                                self.publication_id = 0;
                                self.document_title = "";
                                self.departments = "";
                                self.document_type = "";
                                self.publication_no = "";
                                self.files = [];

                                setTimeout(() => {
                                    self.$refs.documentDropzone.removeAllFiles();
                                }, 100);
                            } else {
                                self.$router.push("/publication/list");
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                });
            }
        },
        loadSinglePublication() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/publication/" + self.publicationId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.code == 200) {
                        self.document_title = data.content.document_title;
                        self.departments = data.content.departments;
                        self.document_type = data.content.document_type;
                        self.publication_no = data.content.publication_number;
                        self.dropZonePreviewFiles = data.content.file_path;

                        if(data.content.departments.length == self.departmentArr.length){
                            var checkbox = document.getElementById('departmentsCheckbox');
                            if(checkbox){
                                checkbox.checked = true;
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/publication/PublicationCreate.vue